import styles from './PartSalesDisabled.module.css'
import buttons from './../../Buttons.module.css'

const PartSalesDisabled = ({ message, onClose }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.container}>
                <div className={styles.icon_wrapper}>
                    <svg className={styles.icon} viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style={{stopColor: '#0060B7', stopOpacity: 1}} />
                                <stop offset="100%" style={{stopColor: '#004A8F', stopOpacity: 1}} />
                            </linearGradient>
                            <filter id="glow">
                                <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                                <feMerge>
                                    <feMergeNode in="coloredBlur"/>
                                    <feMergeNode in="SourceGraphic"/>
                                </feMerge>
                            </filter>
                        </defs>
                        
                        {/* Фоновые круги */}
                        <circle cx="60" cy="60" r="50" fill="url(#blueGradient)" opacity="0.08">
                            <animate attributeName="r" values="50;55;50" dur="3s" repeatCount="indefinite"/>
                            <animate attributeName="opacity" values="0.08;0.03;0.08" dur="3s" repeatCount="indefinite"/>
                        </circle>
                        <circle cx="60" cy="60" r="40" fill="none" stroke="url(#blueGradient)" strokeWidth="2" opacity="0.2">
                            <animate attributeName="r" values="40;43;40" dur="2.5s" repeatCount="indefinite"/>
                            <animate attributeName="opacity" values="0.2;0.35;0.2" dur="2.5s" repeatCount="indefinite"/>
                        </circle>
                        
                        {/* Основной круг */}
                        <circle cx="60" cy="60" r="32" fill="url(#blueGradient)" opacity="0.95" filter="url(#glow)">
                            <animate attributeName="opacity" values="0.95;1;0.95" dur="2s" repeatCount="indefinite"/>
                        </circle>
                        
                        {/* Буква i */}
                        <g transform="translate(60, 60)">
                            {/* Точка над i */}
                            <circle cx="0" cy="-16" r="4" fill="white">
                                <animate attributeName="cy" values="-16;-17;-16" dur="1.5s" repeatCount="indefinite"/>
                            </circle>
                            
                            {/* Вертикальная линия i */}
                            <rect x="-3.5" y="-8" width="7" height="22" rx="3.5" fill="white">
                                <animate attributeName="opacity" values="1;0.9;1" dur="2s" repeatCount="indefinite"/>
                            </rect>
                        </g>
                    </svg>
                </div>
                
                <h2 className={styles.title}>Временная приостановка продаж</h2>
                
                <div className={styles.message}>
                    <p>{message}</p>
                </div>
                
                <div className={styles.footer}>
                    <p className={styles.footer_text}>
                        Просим отнестись с пониманием и проявить терпение.
                    </p>
                    <button 
                        className={`${buttons.btn_solid_blue} ${styles.close_btn}`}
                        onClick={onClose}
                    >
                        Понятно
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PartSalesDisabled;
